import { render, staticRenderFns } from "./scanCard.vue?vue&type=template&id=845d672e&scoped=true"
import script from "./scanCard.vue?vue&type=script&lang=js"
export * from "./scanCard.vue?vue&type=script&lang=js"
import style0 from "./scanCard.vue?vue&type=style&index=0&id=845d672e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845d672e",
  null
  
)

export default component.exports